import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Tags.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "title font-size-h3-large"
  }, [_vm.orderInfo.take_order_channel && [2, 3, 7].indexOf(_vm.orderInfo.take_order_channel) !== -1 ? _c('div', {
    staticClass: "source-icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/" + _vm.sourceIcon[_vm.orderInfo.take_order_channel] + ".png",
      "width": "100%",
      "height": "100%"
    }
  })]) : _vm._e(), _vm.orderInfo.order_sponsor_type === 2 ? _c('div', {
    staticClass: "source-icon"
  }, [_c('img', {
    attrs: {
      "src": "/spa_static_mobile/icon/icon_inside32_32@3x.png",
      "width": "100%",
      "height": "100%"
    }
  })]) : _vm._e(), _c('div', {}, [_vm._v(_vm._s(_vm.orderInfo.title))])]), _c('div', {
    staticClass: "state",
    style: {
      color: _vm.statusColorMapping[_vm.orderInfo.state]
    }
  }, [_vm._v(" " + _vm._s(_vm.orderState) + " ")])]), _c('div', {
    staticClass: "customer font-size-h3-normal"
  }, [_c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("412"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.orderInfo.order_no))])]), _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("155"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.orderInfo.custom_name || ''))])]), _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label-link"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('span', [_vm._v(i18n.tc("413"))]), _c('span', [_vm._v(i18n.tc("414"))]), _c('span', [_vm._v(i18n.tc("415"))])]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.orderInfo.custom_linkperson))])]), _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("157"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.orderInfo.custom_phone))])]), _vm.orderInfo.o_service_address_view === 1 || _vm.orderInfo.c_detailaddress_view === 1 ? _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("242"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm.orderInfo.o_service_address_view === 1 ? [_vm._v(" " + _vm._s(_vm.orderInfo.gps_addr) + _vm._s(_vm.orderInfo.custom_detail_addr === 1 ? ' ' : '') + " ")] : _vm._e(), _vm.orderInfo.c_detailaddress_view === 1 ? _c('span', [_vm._v(" " + _vm._s(_vm.orderInfo.custom_detail_addr) + " ")]) : _vm._e()], 2)]) : _vm._e(), _vm.orderProduct.pname ? _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("416"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.orderProduct.pname))])]) : _vm._e(), _vm.orderInfo.o_appointment_view === 1 ? _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("154"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.orderInfo.custom_apply_time))])]) : _vm._e(), _vm.orderInfo.state === 6 ? _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("417"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.orderInfo.cancel_remark))])]) : _vm._e()]), _c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "tag-line",
    class: {
      'tag-line-close': !_vm.tagLineShow
    }
  }, [_c(__unplugin_components_0, {
    attrs: {
      "list": _vm.taglist
    }
  })], 1)])]), _c('div', {
    staticClass: "tabs"
  }, [_c('Tab', {
    staticClass: "tab-effect",
    attrs: {
      "default-color": "#1a1e24",
      "active-color": "#3ccba6",
      "bar-active-color": "#3ccba6",
      "custom-bar-width": "15px",
      "line-width": 2
    },
    model: {
      value: _vm.tabsIndex,
      callback: function ($$v) {
        _vm.tabsIndex = $$v;
      },
      expression: "tabsIndex"
    }
  }, _vm._l(_vm.tabs, function (item, index) {
    return _c('TabItem', {
      key: index
    }, [_vm._v(_vm._s(item))]);
  }), 1), _c('Swiper', {
    staticClass: "swiper",
    attrs: {
      "show-dots": false,
      "threshold": 100,
      "height": "100%"
    },
    model: {
      value: _vm.tabsIndex,
      callback: function ($$v) {
        _vm.tabsIndex = $$v;
      },
      expression: "tabsIndex"
    }
  }, [_c('SwiperItem', [_c('div', {
    staticClass: "c-process-tetail"
  }, [_c('ul', {
    staticClass: "ul"
  }, _vm._l(_vm.processList, function (item, index) {
    return _c('li', {
      key: index,
      class: ['li', {
        'detail-active': item.finish
      }]
    }, [index != _vm.processList.length - 1 ? _c('div', {
      staticClass: "line"
    }) : _vm._e(), _c('p', {
      staticClass: "dot"
    }, [_c('span', [_c('img', {
      class: {
        'filter-translate': item.finish
      },
      staticStyle: {
        "width": "1.6rem"
      },
      attrs: {
        "src": "/static/toc/mobile/img/progress_" + (item.finish ? 'on' : 'off') + ".png"
      }
    })])]), _c('p', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.time))])]);
  }), 0)]), _c('OrderInfo', {
    attrs: {
      "orderId": _vm.oid,
      "orderInfo": _vm.orderInfo,
      "orderExtFields": _vm.orderExtFields,
      "remarkPicList": _vm.remarkPicList,
      "product": _vm.orderProduct,
      "sortList": _vm.sortList
    }
  })], 1), _vm.isServiceAmount ? _c('SwiperItem', [_c('ServiceAmount', {
    ref: "serviceAmount",
    attrs: {
      "orderId": _vm.oid,
      "reloadflag": _vm.reloadflag,
      "orderInfo": _vm.orderInfo,
      "orderService": _vm.orderService,
      "orderExtFields": _vm.orderExtFields,
      "moneyItemEditRoles": _vm.moneyItemEditRoles,
      "is_view_settlement": 1
    }
  })], 1) : _vm._e(), _vm.isServiceProcess ? _c('SwiperItem', [_c('ServiceProcess', {
    attrs: {
      "orderId": _vm.oid,
      "orderInfo": _vm.orderInfo,
      "orderServiceNodes": _vm.orderServiceNodes,
      "serviceTreeMap": _vm.serviceTreeMap,
      "coordList": _vm.coordList,
      "isEditCoordination": _vm.isEditCoordination
    },
    on: {
      "on-success-editSynergModel": function ($event) {
        return _vm.reload();
      }
    }
  })], 1) : _vm._e(), _vm.isOrderReceipt ? _c('SwiperItem', [_c('OrderExecute', {
    attrs: {
      "oid": _vm.oid,
      "orderInfo": _vm.orderInfo,
      "template": _vm.template
    }
  })], 1) : _vm._e(), _vm.isOrderMessage ? _c('SwiperItem', [_c('OrderMessage', {
    ref: "orderMessage",
    attrs: {
      "oid": _vm.oid,
      "orderInfo": _vm.orderInfo
    }
  })], 1) : _vm._e(), _vm.isCustomerEvaluate ? _c('SwiperItem', [_c('CustomerEvaluate', {
    ref: "customerEvaluate",
    attrs: {
      "oid": _vm.oid,
      "orderInfo": _vm.orderInfo,
      "orderExtFields": _vm.orderExtFields
    }
  })], 1) : _vm._e(), _vm.isShowProductInfo ? _c('SwiperItem', [_c('ProductInfo', {
    ref: "ProductInfo",
    attrs: {
      "orderId": _vm.oid,
      "orderInfo": _vm.orderInfo
    }
  })], 1) : _vm._e(), _vm._l(_vm.detailCtrlList, function (item) {
    return [_c('SwiperItem', {
      key: item.sntid
    }, [_c('DetailCtrlList', {
      attrs: {
        "id": item.sntid,
        "orderId": _vm.oid,
        "config": item
      }
    })], 1)];
  })], 2)], 1)]), _vm.oid && Object.keys(_vm.orderInfo).length > 0 && _vm.hasAuth ? _c('OrderBottomOptions', {
    ref: "orderBottomOptions",
    attrs: {
      "oid": _vm.oid,
      "orderInfo": _vm.orderInfo,
      "template": _vm.template
    },
    on: {
      "on-success": _vm.onSuccessBottomBtn,
      "on-maketag": function ($event) {
        _vm.taglist = $event;
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };